import debounce from "lodash/debounce";
import { filterDropdownData } from "./helper";
import {
  getUsers,
  getProducts,
  getCategories,
  getSubCategories,
  getTags,
  getSizeGuides,
  getDetailedSubCategories,
  getCoupons,
  getVariants,
} from "src/apis";

const delay = 300;

// Users
export const searchUsers = debounce((search, resolve) => {
  getUsers({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, [
      "first_name",
      "last_name",
      "email_address",
    ],true);
    resolve(filter);
  });
}, delay);

// products
export const searchProducts = debounce((search, resolve) => {
  getProducts({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, [
      "category_id.category_name",
      "sub_category_id.sub_category_name",
      "item_name",
      "product_sku",
    ],true);
    resolve(filter);
  });
}, delay);

// Categories
export const searchCategories = debounce((search, resolve) => {
  getCategories({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, ["category_name"]);
    resolve(filter);
  });
}, delay);

// Sub Categories
export const searchSubCategories = debounce((search, resolve) => {
  getSubCategories({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, [
      "category_id.category_name",
      "sub_category_name",
    ]);
    resolve(filter);
  });
}, delay);

//  Deatiled Sub Categories
export const searchDetailedSubCategories = debounce((search, resolve) => {
  getDetailedSubCategories({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, [
      "category_id.category_name",
      "sub_category_id.sub_category_name",
      "detailed_sub_category_name",
    ]);
    resolve(filter);
  });
}, delay);

// Tags
export const searchTags = debounce((search, resolve) => {
  getTags({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, ["tag_name"]);
    resolve(filter);
  });
}, delay);

// SizeGuides
export const searchSizeGuides = debounce((search, resolve) => {
  getSizeGuides({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, ["name"]);
    resolve(filter);
  });
}, delay);

// Coupons
export const searchCoupons = debounce((search, resolve) => {
  getCoupons({ search }).then((res) => {
    const filter = filterDropdownData(res?.data, [
      "coupan_code",
      "coupan_amount",
    ]);
    resolve(filter);
  });
}, delay);

// Variants (inventory / size) – for dropdowns that need inventory _id
export const searchVariants = debounce((search, resolve) => {
  getVariants({ search, limit: 500 }).then((res) => {
    const list = Array.isArray(res) ? res : res?.data || [];
    const filter = filterDropdownData(list, ["size"]);
    resolve(filter);
  });
}, delay);

// Unique size names for dashboard filter – returns options with value = size string (e.g. "S", "XL")
export const searchUniqueSizes = debounce((search, resolve) => {
  getVariants({ search: search || undefined, limit: 500 }).then((res) => {
    const list = Array.isArray(res) ? res : res?.data || [];
    const sizeSet = new Set();
    list.forEach((item) => {
      const s = item && item.size;
      if (s) sizeSet.add(s);
    });
    const sizes = Array.from(sizeSet).sort();
    const options = sizes.map((s) => ({ label: s, value: s }));
    resolve(options);
  });
}, delay);
